import script from "./CongressConnect.vue?vue&type=script&setup=true&lang=js"
export * from "./CongressConnect.vue?vue&type=script&setup=true&lang=js"

import "./CongressConnect.vue?vue&type=style&index=0&id=07760858&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07760858"]])

export default __exports__